import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CurrentUserService } from 'src/app/core/services/current-user.service';

declare var $: any;

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  @Input() title:string;
  @Input() showBack:boolean = true;

  public isDropdownVisible:boolean = false;

  constructor(public currentUserService:CurrentUserService, private location:Location) { }

  ngOnInit() { }

  showMobileNav() {
    $('body').toggleClass('mobile-nav-open');
  }

  showDropdown() {
    if(!this.isDropdownVisible) {
      this.isDropdownVisible = true;

      // let the property get set before adding the close click listener
      setTimeout(() => {
        $(document).one('click', (e) => {
          if($('ul.dropdown').has(e.target).length === 0){
            this.isDropdownVisible = false;
          }
        });
      }, 1);
    } else {
      this.isDropdownVisible = false;
    }
  }

  openPdf() {
    window.open("assets/Hub Group Connect - Reference Guide.pdf", "_blank")
  }

  logout() {
    localStorage.removeItem('show_map');
    this.currentUserService.logout();
  }

  back() {
    this.location.back();
  }

}
